import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this.checkAllChildren();
  }

  checkAllChildren() {
    this.itemTargets.forEach((item) => {
      const parent = item
        .closest("ul")
        .previousElementSibling.querySelector("input[type='checkbox']");
      if (parent) {
        item.querySelectorAll("input[type='checkbox']").forEach((input) => {
          input.addEventListener("change", () => {
            this.checkParent(parent);
          });
        });
        parent.addEventListener("change", () => {
          this.checkChildren(parent, item);
        });
        this.checkParent(parent);
      }
    });
  }

  checkParent(parent) {
    const siblings = parent
      .closest("li")
      .querySelectorAll("input[type='checkbox']");
    const checkedSiblings = Array.from(siblings).filter(
      (sibling) => sibling.checked
    );
    if (checkedSiblings.length === 0) {
      parent.checked = false;
      parent.removeAttribute("partial");
    } else if (checkedSiblings.length === siblings.length) {
      parent.checked = true;
      parent.removeAttribute("partial");
    } else {
      parent.checked = true;
      parent.setAttribute("partial", true);
    }
  }

  checkChildren(parent, item) {
    item.querySelectorAll("input[type='checkbox']").forEach((input) => {
      input.checked = parent.checked;
    });
  }

  selectAllItems(event) {
    event.preventDefault();

    const checkboxes = Array.from(
      document.querySelectorAll('input[type="checkbox"]')
    );

    const checkedCheckboxes = Array.from(checkboxes).filter(
      (checkboxe) => checkboxe.checked
    );

    checkboxes.forEach((checkbox) => {
      if (checkedCheckboxes.length === checkboxes.length) {
        checkbox.checked = false;
        checkbox.removeAttribute("partial");
      } else {
        checkbox.checked = true;
        checkbox.removeAttribute("partial");
      }
    });
  }
}
